import { apiClient } from './api'

export interface ProcedureType {
  procedureTypeCode: string
  procedureName: string
  description: string | null
  category: string | null  // 旧カラム（非推奨）
  categoryCode: string  // V22で追加
  active: boolean
  displayOrder: number
  createdAt: string
  createdBy: string | null
  updatedAt: string
  updatedBy: string | null
  version: number
}

export interface CreateProcedureTypeRequest {
  procedureTypeCode: string
  procedureName: string
  description?: string
  categoryCode: string
  active?: boolean
  displayOrder?: number
}

export interface UpdateProcedureTypeRequest {
  procedureName: string
  description?: string
  categoryCode: string
  active: boolean
  displayOrder: number
  version: number
}

export class ProcedureTypeService {
  static async getAll(params?: {
    keyword?: string
    categoryCode?: string
    active?: boolean
  }): Promise<{ items: ProcedureType[]; total: number }> {
    const queryParams = new URLSearchParams()
    if (params?.keyword) queryParams.append('keyword', params.keyword)
    if (params?.categoryCode) queryParams.append('categoryCode', params.categoryCode)
    if (params?.active !== undefined) queryParams.append('active', String(params.active))

    const queryString = queryParams.toString()
    const url = queryString ? `/api/procedure-types?${queryString}` : '/api/procedure-types'
    return apiClient.get<{ items: ProcedureType[]; total: number }>(url)
  }

  static async getByCode(code: string): Promise<ProcedureType> {
    return apiClient.get<ProcedureType>(`/api/procedure-types/${code}`)
  }

  static async create(request: CreateProcedureTypeRequest): Promise<ProcedureType> {
    return apiClient.post<ProcedureType>('/api/procedure-types', request)
  }

  static async update(code: string, request: UpdateProcedureTypeRequest): Promise<ProcedureType> {
    return apiClient.put<ProcedureType>(`/api/procedure-types/${code}`, request)
  }

  static async updateActive(code: string, active: boolean, version: number): Promise<ProcedureType> {
    return apiClient.patch<ProcedureType>(`/api/procedure-types/${code}/active`, { active, version })
  }

  static async getStats(code: string): Promise<{ publishedBindingsCount: number }> {
    return apiClient.get<{ publishedBindingsCount: number }>(`/api/procedure-types/${code}/stats`)
  }

  static async delete(code: string): Promise<void> {
    return apiClient.delete(`/api/procedure-types/${code}`)
  }
}
